import axios from 'axios';
import { getServerUrlCandidates } from '../../utils/serverUrl';

const getTransactionUrls = () => {
  const candidates = getServerUrlCandidates("/garagedata/transactions");
  const configured = process.env.REACT_APP_TRANSACTIONS_URL;
  if (configured && !candidates.includes(configured)) {
    candidates.push(configured);
  }
  return candidates;
};

const fetchTransactions = async (urlCandidates, requestConfig) => {
  let lastError = null;
  for (const url of urlCandidates) {
    try {
      return await axios.get(url, requestConfig);
    } catch (error) {
      lastError = error;
      if (error?.response?.status === 401) {
        throw error;
      }
    }
  }
  throw lastError;
};

const automatedGarageAPI = async (garageName, automatedSetFailedtoLoad, setResponse, setTotal, formattedDate, setIsLoading, nav) => {
    console.log(formattedDate);

  let data = null;
  const token = sessionStorage.getItem('token');
  const garageInfo = JSON.parse(localStorage.getItem(`${garageName}Info`))
  const databaseConnection = garageInfo.databaseConnection;
  const spaces = garageInfo.spaces; 
  const garageType = garageInfo.garageType;

  try {
    const response = await fetchTransactions(getTransactionUrls(), {
      params: {
        inDate: formattedDate,
        outDate: formattedDate,
        garage: garageName,
        connection: databaseConnection,
        spaces,
        garageType,
      },
      headers: {
        authorization: 'Bearer ' + token
      }
    });
    data = response?.data;
    if (!data) {
      throw new Error("No data returned from transactions API.");
    }
    console.log(data);
    setResponse(data);
    setIsLoading(false)
    if (data?.ticketStats?.[0]?.Total != null) {
      setTotal(data.ticketStats[0].Total);
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      nav('/login');
      return;
    }
    console.log(err)
    automatedSetFailedtoLoad(true);
    setIsLoading(false);
  }
};

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function formatDate(date) {
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join('-');
}

export {padTo2Digits, formatDate, automatedGarageAPI};